import { jsx as _jsx } from "react/jsx-runtime";
import { GripVertical } from "lucide-react";
import { cn } from "../../../utils";
/**
 * The grip button that activates drag-to-reorder. Owns the canonical drag
 * affordance (grab cursor, `touch-none`, activator ref, dnd-kit listeners) and
 * stops click propagation so a click on the grip never triggers the row's own
 * click handler. Shared by every sortable list so the affordance stays
 * consistent; callers tune only colour/spacing via `className` and `size`.
 */ export function DragHandle({ label, setActivatorNodeRef, attributes, listeners, size = 16, className }) {
    return /*#__PURE__*/ _jsx("button", {
        type: "button",
        ref: setActivatorNodeRef,
        "aria-label": label,
        title: label,
        onClick: (e)=>e.stopPropagation(),
        className: cn("rounded-sm transition-colors cursor-grab touch-none active:cursor-grabbing", className),
        ...attributes,
        ...listeners,
        children: /*#__PURE__*/ _jsx(GripVertical, {
            size: size
        })
    });
}

//# sourceMappingURL=DragHandle.js.map